<template>
  <slot :open-pannel="() =>setOpen(true)" />
  <TransitionRoot
    as="template"
    :show="open"
  >
    <Dialog
      as="div"
      class="fixed inset-0 flex z-40 lg:hidden"
      @close="setOpen(false)"
    >
      <TransitionChild
        as="template"
        enter="transition-opacity ease-linear duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="transition-opacity ease-linear duration-300"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-black bg-opacity-25 transition-opacity" />
      </TransitionChild>
      <TransitionChild
        as="template"
        enter="transition ease-in-out duration-300 transform"
        enter-from="-translate-x-full"
        enter-to="translate-x-0"
        leave="transition ease-in-out duration-300 transform"
        leave-from="translate-x-0"
        leave-to="-translate-x-full"
      >
        <div class="relative max-w-xs w-full bg-white shadow-xl flex flex-col">
          <div class="overflow-y-auto h-full">
            <TheMainMenuMobileHeader
              :set-open="setOpen"
              :logo="logo"
              :image-proxy-url="imageProxyUrl"
            />
            <nav :aria-label="menu.title">
              <ul class="divide-y divide-gray-800 border-y border-gray-800">
                <li>
                  <TheMainMenuMobilePannel
                    :item="{ label: trans.get('miliboo.menu.our_products'), child_menu: categoryMenu.menuItems }"
                    :image-proxy-url="imageProxyUrl"
                    @close="setOpen(false)"
                  />
                </li>
                <li
                  v-for="item in menu.menuItems"
                  :key="item.id"
                >
                  <a
                    class="w-full flex items-center p-4"
                    :href="`/${item.slug}`"
                  >
                    <span class="text-left font-semibold flex-grow text-lg text-gray-700">
                      {{ item.label }}
                    </span>
                  </a>
                </li>
                <TheMainMenuMobileSecondary :secondary-menu="secondaryMenu" />
              </ul>
            </nav>
          </div>
          <TheMainMenuMobileFooter />
        </div>
      </TransitionChild>
    </Dialog>
  </TransitionRoot>
</template>
<script setup>
import { inject } from 'vue';
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue';
import useOpen from '../../composables/useOpen';
import TheMainMenuMobilePannel from './TheMainMenuMobilePannel.vue';
import TheMainMenuMobileFooter from './TheMainMenuMobileFooter.vue';
import TheMainMenuMobileSecondary from './TheMainMenuMobileSecondary.vue';
import TheMainMenuMobileHeader from './TheMainMenuMobileHeader.vue';

const trans = inject('translate');

defineProps({
  menu: {
    type: Object,
    required: true,
  },
  secondaryMenu: {
    type: Object,
    required: true,
  },
  categoryMenu: {
    type: Object,
    required: true,
  },
  logo: {
    type: String,
    required: true,
  },
  imageProxyUrl: {
    type: String,
    required: true,
  },
});

const { open, setOpen } = useOpen();

</script>
